import React from 'react';
import styles from './style.module.scss';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CommercialPropertyBoundaryItem } from '@zoocasa/go-search';
import imageLoader from 'components/listing-image/image-loader';

export type ListingCardProps = CommercialPropertyBoundaryItem;

type CommercialTitleParams = Pick<CommercialPropertyBoundaryItem, 'name' | 'unparsedAddress' | 'city' | 'stateOrProvince'>;
export const getCommercialTitle = ({ name, unparsedAddress, city, stateOrProvince }: CommercialTitleParams) => {
  const titles = name ?? unparsedAddress;
  const addressChunks = [unparsedAddress, city, stateOrProvince];
  if (titles === unparsedAddress) {
    addressChunks.shift();
  }
  return addressChunks.filter(Boolean).join(', ');
};

export default function ListingCard(props: ListingCardProps) {
  const { name, thumbnailImage, unparsedAddress, city, isSale,
    stateOrProvince, priceLabel, buildingSize, propertySubType, slug } = props;
  const title = name ?? unparsedAddress;

  const meta = [
    priceLabel,
    buildingSize,
    propertySubType,
  ];

  const badge = isSale ? 'For Sale' : 'For Lease';
  let imageSrc = '/next/assets/images/exp-commercial/commercial-no-listing-image.webp';
  if (thumbnailImage) {
    imageSrc = imageLoader({ src: thumbnailImage, isListingCardImage: true });
  }
  return (
    <Card variant='outlined'>
      <CardActionArea component='a' href={`/listings/${slug}`} sx={{ textDecoration: 'none !important' }}>
        <div className={styles.media}>
          <CardMedia
            component="img"
            image={imageSrc}
            alt={name}
            className={styles.image}
          />
          <span className={styles.badge}>{badge}</span>
        </div>
        <CardContent className={styles.content}>
          <h3 className={styles.title}>{title}</h3>
          <address className={styles.address}>{getCommercialTitle({ name, unparsedAddress, city, stateOrProvince })}</address>
          <div className={styles.meta}>
            {meta.filter(Boolean).map((item, index, array) => (
              <React.Fragment key={item}>
                {item}
                {index < array.length - 1 && <Divider orientation="vertical" flexItem sx={{ borderColor: 'rgba(206, 207, 211, 1)' }} />}
              </React.Fragment>
            ))}
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}


